import { Constant } from '@app/const';
import NoteNodeModel from '@app/models/nodes/NoteNodeModel';
import CreateObjects from '@app/utilities/CreateObjects';

type DragNodeFactory = () => any;

type ComponentPanelOptions = {
  fromToolBar?: boolean;
  suppressPropertyPanel: boolean;
  toolBarNode: boolean;
};

const componentPanelOptions: Record<string, ComponentPanelOptions> = {
  'icon-package': {
    suppressPropertyPanel: true,
    toolBarNode: true
  },
  'icon-mic': {
    suppressPropertyPanel: true,
    toolBarNode: true
  },
  'icon-message-square': {
    fromToolBar: true,
    suppressPropertyPanel: true,
    toolBarNode: true
  },
  'icon-cpu': {
    suppressPropertyPanel: true,
    toolBarNode: true
  }
};

type NoteNodeFactory = new () => InstanceType<typeof NoteNodeModel>;

const dragNodeFactories: Record<string, DragNodeFactory> = {
  // Historical W2 contract: no-arg NoteNodeModel().serialize() (id optional at runtime).
  'icon-note': () => new (NoteNodeModel as unknown as NoteNodeFactory)().serialize(),
  'icon-package': () => CreateObjects.createModule(),
  'icon-mic': () => CreateObjects.createInput(),
  'icon-message-square': () => CreateObjects.createPrompt(),
  'icon-cpu': () => CreateObjects.createCustom()
};

export function runToolbarDragPayload(itemId: string): void {
  const createNode = dragNodeFactories[itemId];

  if (!window.apm || !createNode) {
    return;
  }

  const node = createNode();

  if (itemId !== 'icon-note') {
    node.props.timeAddedToFlow = window.apm.timestamp;
  }

  window.apm.cache.put(
    Constant.k.NAMESPACE_DATATRANSFER,
    'dragndrop',
    node
  );

  const options = componentPanelOptions[itemId];

  if (options) {
    window.apm.postEventToCurrentView({
      event: node,
      target: 'request-component-panel',
      ...options
    });
  }
}
